import React, { useEffect, useState } from 'react'
import { ApiService } from '../Services/apiServices';
import { Link } from 'react-router-dom';

const Footer = () => {

  const [settings, setSettings] = useState("");
  const [company, setCompany] = useState([]);
  const [products, setProducts] = useState([]);


  useEffect(() => {
    const fetchsettings = async () => {
      try {
        const settingData = await ApiService.Commanfetchrequest('setting');
        setSettings(settingData);
        // console.log('setting data:', settingData);
      } catch (error) {
        console.log('error while fetching:', error);
      }
    }

    const fetchcompany = async () => {
      try {
        const companyData = await ApiService.Commanfetchrequest('company');
        setCompany(companyData);
        // console.log('company data:', companyData);
      } catch (error) {
        console.log('error while fetching:', error);
      }
    }

    const fetchMenuData = async () => {
      try {
        const getMenuData = await ApiService.Commanfetchrequest('menu');
        const productCategory = getMenuData.headermenu.find(
          (category) => category.category_name === 'Products'
        );

        if (productCategory && productCategory.subcategories) {
          setProducts(productCategory.subcategories);
        }

        // console.log('Menu data:', getMenuData);
      } catch (error) {
        console.log('Error in fetching menu data:', error);
      }
    };


    fetchsettings();
    fetchcompany();
    fetchMenuData();
  }, []);

  return (

    <footer id="footer" className="footer position-relative light-background"
      style={{ backgroundColor: '#020b17', color: '#fff' }}>
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="/" className="logo d-flex align-items-center">
              <span style={{ color: '#fff' }} className="sitename">Sigo<span style={{color:'green'}}>Hrm</span></span>
            </a>
            <p>SigoHrm is India’s leading HRM and payroll software designed to simplify and streamline human resource management processes for businesses of all sizes. </p>
            <div className="footer-contact pt-3" style={{ color: '#cdd4e0' }}>
              {settings ? (
                <>

                  <p><i className="bi bi-geo-alt-fill" style={{ marginRight: 8 }}></i> {settings?.site_address || 'Jaipur Rajasthan'}</p>
                  <p className="mt-3"><strong><i className="bi bi-telephone-fill" style={{ marginRight: 8, color: 'green' }}></i></strong> <a style={{ color: '#cdd4e0' }} href={"tel:" + settings?.site_phone}>{settings?.site_phone || '+1 5589 55488 55'}</a></p>
                  <p className="mt-2"><strong><i className="bi bi-envelope-fill" style={{ marginRight: 8, color: 'blue' }}></i></strong> <a style={{ color: '#cdd4e0' }} href={"mailto:" + settings?.site_email}>{settings?.site_email || 'info@example.com'}</a></p>
                </>
              ) : (
                ""
              )}

            </div>
            <div className="social-links d-flex mt-4">
              {settings?.twitter_url != null ? (
                <>
                  <a style={{ color: '#cdd4e0' }} href={settings?.twitter_url} target='new'><i className="bi bi-twitter-x" /></a>
                </>
              ) : (
                ""
              )}

              {settings?.facebook_url != null ? (
                <>
                  <a style={{ color: '#cdd4e0' }} href={settings?.facebook_url} target='new'><i className="bi bi-facebook" /></a>
                </>
              ) : (
                ""
              )}

              {settings?.instagram_url != null ? (
                <>
                  <a style={{ color: '#cdd4e0' }} href={settings?.instagram_url} target='new'><i className="bi bi-instagram" /></a>
                </>
              ) : (
                ""
              )}

              {settings?.linkdein_url != null ? (
                <>
                  <a style={{ color: '#cdd4e0' }} href={settings?.linkdein_url} target='new'><i className="bi bi-linkedin" /></a>
                </>
              ) : (
                <a style={{ color: '#cdd4e0' }} href=""><i className="bi bi-linkedin" /></a>
              )}
            </div>
          </div>


          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              {company?.map((value, index) => {
                return (
                  <>
                    <li key={index}>
                      <a style={{ color: '#cdd4e0' }} href={value?.url}>{value?.title}</a>
                    </li>
                  </>
                )
              })}
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Products</h4>
            <ul>
              {products?.length > 0 ? (
                products?.map((subcategory) => (
                  <li key={subcategory?.id}>
                    <Link to={`/product/${subcategory?.url}`} style={{ color: '#cdd4e0' }}>
                      {subcategory?.category_name}
                    </Link>
                  </li>
                ))
              ) : (
                ""
              )}
            </ul>
          </div>
          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p style={{ color: '#cdd4e0' }}>Subscribe to our newsletter and receive the latest news about our products and services!</p>
            <form action="forms/newsletter.php" method="post" className="php-email-form">
              <div className="newsletter-form"><input type="email" name="email" /><input type="submit" defaultValue="Subscribe" /></div>
              <div className="loading">Loading</div>
              <div className="error-message" />
              <div className="sent-message">Your subscription request has been sent. Thank you!</div>
            </form>
          </div>
        </div>
      </div>
      <div className="container copyright text-center mt-4">
        <p>© <span>Copyright</span> <strong className="px-1 sitename">SigoHrm</strong><span>All Rights Reserved</span></p>
      </div>

    </footer>



  )
}

export default Footer
